import { blobToBase64 } from "src/contexts/_shared/infrastructure/files/BlobToBase64";
import { StorageFileWithContent } from "../../domain/StorageFileWithContent";
import { DocumentWithContentAcceptedContentType } from "../../domain/valueObjects/DocumentWithContentAcceptedContentType";
import { DocumentWithContentFileExtension } from "../../domain/valueObjects/DocumentWithContentFileExtension";

export async function fileToDocumentWithContent(file: File): Promise<StorageFileWithContent> {
  const base64File = await blobToBase64(file);

  return new StorageFileWithContent({
    content: base64File,
    contentType: new DocumentWithContentAcceptedContentType(file.type),
    extension: DocumentWithContentFileExtension.fromContentType(file.type),
    name: file.name,
  });
}
